var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.2,
    height: 23.2,
    viewBox: "0 0 21.2 23.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(-23.9 -552.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(-1216.951 327.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(-0.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(-1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M1260.655,240.578a5.258,5.258,0,0,0-1.2-2.205l-.778,1.13a3.682,3.682,0,0,1,.819,2.4,1.113,1.113,0,0,1-1.182,1.067c-1.747.005-3.494,0-5.24,0-1.7,0-3.41,0-5.118,0a1.128,1.128,0,0,1-1.258-1.285,3.7,3.7,0,0,1,3.458-3.56q2.576-.066,5.152-.016l.911-1.2a5.5,5.5,0,0,0-.58.087h-5.063a4.994,4.994,0,0,0-5.2,4.665,2.248,2.248,0,0,0,2.516,2.453c1.737-.042,3.674-.1,5.414-.1l5.125.035c.02,0-.019,0,0,0a2.243,2.243,0,0,0,2.069-1.094A2.819,2.819,0,0,0,1260.655,240.578Z",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M1253.1,227.028a4.206,4.206,0,1,0,4.195,4.2A4.195,4.195,0,0,0,1253.1,227.028Zm-.031,7.076a2.88,2.88,0,1,1,2.888-2.866A2.867,2.867,0,0,1,1253.066,234.1Z",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(14.174 -65.499) rotate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M1259.928,236.113l-.012-.057-.042.009c-.006,0,0,.046-.01.054l-.016.043c-.311.472-.622.953-.935,1.427a.135.135,0,0,1-.012.021q-1.208,1.831-2.418,3.664l0,.007-.005.01a.36.36,0,0,1-.165.141c-.5.237-1,.477-1.5.716l-.054.023c0-.087.008-.161.009-.236.005-.1.009-.2.014-.3v-.014a12.019,12.019,0,0,1,.053-1.229h0a.1.1,0,0,1,.011-.053l0-.009a.187.187,0,0,1,.019-.04q1.336-2.028,2.678-4.058.363-.552.729-1.106c.012-.019.045-.039.056-.054Z",
    fill: "#7e97b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M1260.626,234.995c-.119.2-.262.391-.394.588-.521-.346-1.047-.69-1.568-1.035a.157.157,0,0,1,.016-.032l.325-.5a.948.948,0,0,1,1.621.978Z",
    fill: "#7e97b8"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 20,
    height: 22,
    rx: 3,
    transform: "translate(24.5 553)",
    fill: "none",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profile-pic.67e6bd7b0ba439f363f386995bdbc4ee.svg";
export { ForwardRef as ReactComponent };